// extracted by mini-css-extract-plugin
export default {"option":"StopSelectOption_option__vQc35","name":"StopSelectOption_name__Y-kPu","address":"StopSelectOption_address__-K4w2"};